import { jsonApi } from '../jsonApi';

jsonApi.define('tms/web-trigger', {
  id: '',
  name: '',
  type: '',
  is_default: false,
  bin: false,
  id_tagcommander: '',
});
